export default __webpack_public_path__ + "static/media/gallery-11.6e48f44a.png";